<template>
  <div class="control-switch text--primary">
    <span class="control-switch__label text-legend">{{ label }}</span>

    <div class="switch">
      <input
        v-model="currentState"
        @input="updateCurrentState"
        :id="inputElId"
        class="cmn-toggle cmn-toggle-round-flat dtm-button"
        type="checkbox"
        :button_name="taggingAttr"
      />
      <label :for="inputElId"></label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SwitchCom',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: 'Label',
    },
    inputElId: String,
    taggingAttr: String,
  },
  data: () => ({
    currentState: false,
  }),
  created() {
    this.currentState = this.value;
  },
  methods: {
    updateCurrentState(e) {
      this.$emit('input', e.target.checked);
    },
  },
};
</script>

<style lang="scss" scoped>
.control-switch {
  display: inline-block;

  &:first-child {
    margin-left: 0;
  }

  &__label {
    margin-right: 15px;
  }

  .switch {
    display: inline-block;
    vertical-align: middle;
  }
}

.cmn-toggle {
  position: absolute;
  margin-left: -9999px;
  visibility: hidden;
}

.cmn-toggle + label {
  display: block;
  position: relative;
  cursor: pointer;
  outline: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

input.cmn-toggle-round-flat + label {
  padding: 2px;
  width: 75px;
  height: 30px;
  background-color: #dddddd;
  -webkit-border-radius: 60px;
  -moz-border-radius: 60px;
  -ms-border-radius: 60px;
  -o-border-radius: 60px;
  border-radius: 60px;
  -webkit-transition: background 0.4s;
  -moz-transition: background 0.4s;
  -o-transition: background 0.4s;
  transition: background 0.4s;
}

input.cmn-toggle-round-flat + label:before,
input.cmn-toggle-round-flat + label:after {
  display: block;
  position: absolute;
  content: '';
}

input.cmn-toggle-round-flat + label:before {
  top: 2px;
  left: 2px;
  bottom: 2px;
  right: 2px;
  background-color: #fff;
  -webkit-border-radius: 60px;
  -moz-border-radius: 60px;
  -ms-border-radius: 60px;
  -o-border-radius: 60px;
  border-radius: 60px;
  -webkit-transition: background 0.4s;
  -moz-transition: background 0.4s;
  -o-transition: background 0.4s;
  transition: background 0.4s;
}

input.cmn-toggle-round-flat + label:after {
  top: 4px;
  left: 4px;
  bottom: 4px;
  width: 22px;
  background-color: #dddddd;
  -webkit-border-radius: 52px;
  -moz-border-radius: 52px;
  -ms-border-radius: 52px;
  -o-border-radius: 52px;
  border-radius: 52px;
  -webkit-transition: margin 0.4s, background 0.4s;
  -moz-transition: margin 0.4s, background 0.4s;
  -o-transition: margin 0.4s, background 0.4s;
  transition: margin 0.4s, background 0.4s;
}

input.cmn-toggle-round-flat:checked + label {
  background-color: #005eb8;
}

input.cmn-toggle-round-flat:checked + label:after {
  margin-left: 45px;
  background-color: #005eb8;
}
</style>
